import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//Simple bar
import SimpleBar from "simplebar-react";

import SidebarContent from "./SidebarContent";
import { changeSidebarType } from "./../../../store/reducers/generalActions";

// Matches $sidebar-collapsed-width in _variables.scss
const SIDEBAR_COLLAPSED_WIDTH = 70;

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      condensedTip: null, // { label, y } — shown when hovering a nav item in condensed mode
    };
  }

  handleNavHover = (label, y) => {
    this.setState({ condensedTip: { label, y } });
  };

  handleNavLeave = () => {
    this.setState({ condensedTip: null });
  };

  render() {
    const isCondensed = this.props.type === "condensed";
    const { condensedTip } = this.state;

    return (
      <React.Fragment>
        <div
          className="vertical-menu vertical-menu-enterprise"
          style={{ backgroundColor: "#ffffff", overflow: "visible" }}
        >
          {/* Invisible 8px hover strip on right edge (4px inside + 4px outside) */}
          <div className="sidebar-edge-hover" />
          <button
            className="sidebar-collapse-btn"
            onClick={() =>
              this.props.dispatch(
                changeSidebarType(isCondensed ? "default" : "condensed", this.props.isMobile)
              )
            }
            aria-label={isCondensed ? "Expand sidebar" : "Collapse sidebar"}
            data-tip={isCondensed ? "Expand" : "Collapse"}
          >
            <i className={`mdi mdi-chevron-${isCondensed ? "right" : "left"}`}></i>
          </button>

          {/* Always use SimpleBar so condensed mode also gets scrollable menu */}
          <SimpleBar style={{ maxHeight: "100%", height: "100%" }}>
            <SidebarContent
              onNavHover={this.handleNavHover}
              onNavLeave={this.handleNavLeave}
            />
          </SimpleBar>

          {/* Condensed tooltip: rendered outside SimpleBar so it is never clipped by overflow */}
          {isCondensed && condensedTip && (
            <div
              style={{
                position: "fixed",
                left: SIDEBAR_COLLAPSED_WIDTH + 8,
                top: condensedTip.y,
                transform: "translateY(-50%)",
                background: "#343a40",
                color: "#fff",
                padding: "3px 10px",
                borderRadius: "6px",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: 1.6,
                whiteSpace: "nowrap",
                zIndex: 1005,
                pointerEvents: "none",
              }}
            >
              {condensedTip.label}
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  return {
    layout: state.Layout,
    user: state.auth.user,
    type: state.generalActions.leftSideBarType,
  };
};
export default connect(mapStatetoProps)(withRouter(Sidebar));
